import { createContext } from '../utils';
const [TableProvider, useTableContext] = createContext({ isOptional: true });
export { TableProvider, useTableContext };
